<template>
  <div class="generalContainer">
    <div class="contentTable">
      <table style="width: 100%">
        <thead
          style="
            color: whitesmoke;
            background: #3a4750;
            text-align: center;
            height: 28px;
          "
        >
          <tr style="width: 100%">
            <th style="width: 5%">Nº</th>
            <th style="width: 10%">Data Inicio</th>
            <th style="width: 10%">Data Fim</th>
            <th style="width: 10%">Data Entrega</th>
            <th style="width: 20%">Cliente</th>
            <th style="width: 20%">Funcionário</th>
            <th style="width: 14%">Situação</th>
            <th style="width: 10%">Valor Total</th>
            <th style="width: 10%">Ações</th>
          </tr>
        </thead>
        <tbody
          v-if="productionOrders.length"
          style="color: #3a4750; width: 100%"
        >
          <tr
            v-for="productionOrder in productionOrders"
            :key="productionOrder.id"
            style="text-align: center; height: 30px"
          >
            <td style="text-align: center">
              {{ productionOrder.numero }}
            </td>
            <td>
              {{
                productionOrder.dataInicio
                  ? formatDate(productionOrder.dataInicio)
                  : "--"
              }}
            </td>
            <td>
              {{
                productionOrder.dataFim
                  ? formatDate(productionOrder.dataFim)
                  : "--"
              }}
            </td>
            <td>
              {{
                productionOrder.dataEntrega
                  ? formatDate(productionOrder.dataEntrega)
                  : "--"
              }}
            </td>
            <td>
              {{ productionOrder.nomeCliente }}
            </td>
            <td>{{ productionOrder.nomeFuncionario || "Não informado" }}</td>
            <td style="width: 150px">
              <InputSelect
                :items="situationsOptions"
                valueField="value"
                textField="text"
                :enableIconCreate="false"
                :dataSelect.sync="productionOrder.situacao"
                :dataInput="productionOrder.situacao"
                :verifyDataInput="productionOrder.situacao"
                isVerifyDataInput
                ref="productionOrders"
                @changed="
                  updateSituation(productionOrder.id, productionOrder.situacao)
                "
                textCenter
              />
            </td>
            <td>
              {{
                productionOrder.valorTotal
                  ? productionOrder.valorTotal.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : "R$ 0,00"
              }}
            </td>
            <td style="display: flex; justify-content: center; width: 100%">
              <div class="btnActions">
                <b-dropdown
                  id="dropdown-1"
                  class="btnActions"
                  size="sm"
                  variant="none"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                  </template>
                  <b-dropdown-item
                    @click="findProductionOrderById(productionOrder.id)"
                  >
                    Editar
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!productionOrder.numeroVendaMtq"
                    @click="generateSaleSquareMeter(productionOrder.id)"
                  >
                    Gerar Venda MT2
                  </b-dropdown-item>
                  <b-dropdown-item @click="handleDuplicate(productionOrder.id)">
                    Clonar
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="printProductionOrder(productionOrder.id)"
                  >
                    Imprimir
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="productionOrder.response"
                    @click="openPdf(productionOrder.url_pdf)"
                  >
                    Abrir PDF
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="getIdToRemoveOrderService(productionOrder.id)"
                    v-b-modal.modalConfirmDeletion
                  >
                    Excluir
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <td colspan="9">
            <div class="defaultSearch">
              <span>Ops!... nenhum resultado encontrado</span>
            </div>
          </td>
        </tbody>
        <div v-if="spin" class="loadingLazy">
          <div class="loader"></div>
        </div>
      </table>
    </div>

    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="this.productionOrders.length < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>

    <b-modal
      id="modalConfirmDeletion"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div>
        <h6 class="titleModal">Deseja excluir essa movimentação ?</h6>
        <div class="btnModal">
          <button class="btnContent" @click="deleteOrder">Deletar</button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modalConfirmDeletion')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

import ServiceProductionOrder from "../../services/serviceProductionOrder";

import { HandleErrors } from "../../utils/handleErrors";
import print from "../../reports/productionOrder";

export default {
  props: {
    productionOrders: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Number,
      default: 1,
    },
    nextPage: {
      type: Function,
    },
    previousPage: {
      type: Function,
    },
  },
  components: {
    InputSelect,
  },
  data() {
    return {
      spin: false,
      idToRemoveOrderService: "",
      situationsOptions: [
        { value: "pendente", text: "Pendente" },
        { value: "aprovado", text: "Aprovado" },
        { value: "em_separacao", text: "Em separacao" },
        { value: "producao", text: "Produção" },
        { value: "pronta_entrega", text: "Pronta entrega" },
        { value: "finalizado", text: "Finalizado" },
        { value: "cancelado", text: "Cancelado" },
        { value: "pausado", text: "Pausado" },
      ],
    };
  },
  methods: {
    ...mapMutations([
      "SET_DATA_SEARCH_FROM_PRODUCTION_ORDER",
      "SET_SALE_SQUARE_METER_ID",
    ]),
    async updateSituation(id, situacao) {
      try {
        await ServiceProductionOrder.updateSituation(id, { situacao });

        this.$toast.open({
          message: `Situação alterado para (${
            this.situationsOptions.find((s) => s.value === situacao).text
          })`,
          type: "success",
        });

        this.$emit("situationUpdated");
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message: "Ocorreu um erro ao atualizar o situação",
          type: "info",
        });
      }
    },

    async findProductionOrderById(id) {
      const data = await ServiceProductionOrder.findById(id);
      this.handleEdit(data);
    },

    async deleteOrder() {
      try {
        await ServiceProductionOrder.delete(this.idToRemoveOrderService);

        this.idToRemoveOrderService = "";

        this.$bvModal.hide("modalConfirmDeletion");
        this.$emit("deletedProcutionOrder");

        return this.$toast.open({
          message: "Movimentação Excluida!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao deletar!",
          type: "info",
        });
      }
    },

    async generateSaleSquareMeter(id) {
      try {
        const saleSquareMeterId =
          await ServiceProductionOrder.generateSaleSquareMeter(id);

        this.goToSaleSquareMeter(saleSquareMeterId);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao gerar venda MT2",
          type: "info",
        });
      }
    },

    goToSaleSquareMeter(saleSquareMeterId) {
      this.SET_SALE_SQUARE_METER_ID(saleSquareMeterId);

      this.$toast.open({
        message: "Venda MT2 gerada com sucesso!",
        type: "success",
      });

      this.$router.push({
        path: "/vendas-mt",
      });
    },

    getIdToRemoveOrderService(id) {
      this.idToRemoveOrderService = id;
    },

    async openPdf(pdf) {
      try {
        window.open(`${pdf}`, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    handleEdit(productionOrder) {
      this.SET_DATA_SEARCH_FROM_PRODUCTION_ORDER(productionOrder);
      this.$emit("openToEdit");
    },

    async handleDuplicate(productionOrderId) {
      try {
        const newProductionOrderId = await ServiceProductionOrder.duplicate(
          productionOrderId
        );

        await this.findProductionOrderById(newProductionOrderId);

        this.$toast.open({
          message: "P.P Simples clonada com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao clonar",
          type: "info",
        });
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    printProductionOrder(productionOrderId) {
      print("simple", productionOrderId);
    },
  },
};
</script>

<style scoped>
.generalContainer {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  overflow: auto;
  padding: 10px 20px;
  width: 100%;
  max-width: 100%;
}

.contentTable {
  width: 100%;
  max-width: 100%;
  flex-grow: 1;
  overflow: auto;
  padding-right: 0.3rem;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  display: flex;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: normal;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.spin {
  position: absolute;
  right: 5px;
  height: 18px;
  width: 18px;
  color: white;
}

.btnContent {
  position: relative;
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #00486e;
  background: white;
}

.setBtn {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 1rem;
  gap: 10px;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #3e66ae;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

@media screen and (max-width: 700px) {
  .generalContainer {
    padding: 20px 0 !important;
  }
}
</style>